import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';
import addIdsToSegmentationDataInApiResponse, {
  type RevenueInsightMultiPropertyApiResponse,
} from 'lumen/utils/revenue-insight/model-utils';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class ReviMultiPropertyApiResponse extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    remainingElements: { embedded: 'always' },
    reservations: { embedded: 'always' },
    exchangeRates: { embedded: 'always' },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: RevenueInsightMultiPropertyApiResponse,
    id: string | number,
    requestType: string,
  ) {
    const allSegmentation = payload.reservations?.['all']?.[0];
    const payloadId = (allSegmentation?.['id'] as string).replace(
      'all',
      'data',
    );

    payload.exchange_rates.forEach((exchangeRate) => {
      exchangeRate.id = exchangeRate.code;
    });

    addIdsToSegmentationDataInApiResponse(payload.reservations);
    addIdsToSegmentationDataInApiResponse(payload.remaining_elements);

    const restPayload = {
      'revi-multi-property-api-responses': [
        {
          ...payload,
          remaining_elements: {
            ...payload.remaining_elements,
            id: payloadId,
          },
          reservations: {
            ...payload.reservations,
            id: payloadId,
          },
          id: payloadId,
        },
      ],
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalizeResponse(
      store,
      primaryModelClass,
      restPayload,
      id,
      requestType,
    );
  }
}
